import { useEffect, useRef } from "react";

type ResignConfirmProps = {
  onCancel: () => void;
  onConfirm: () => void;
  isSubmitting: boolean;
  error?: string | null;
};

export function ResignConfirm({
  onCancel,
  onConfirm,
  isSubmitting,
  error = null,
}: ResignConfirmProps) {
  const cancelButtonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    cancelButtonRef.current?.focus();

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onCancel();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onCancel]);

  return (
    <section
      className="resign-confirm"
      role="dialog"
      aria-labelledby="resign-confirm-title"
    >
      <p id="resign-confirm-title" className="resign-confirm__question">
        Are you sure you want to resign?
      </p>
      <div className="resign-confirm__actions">
        <button
          ref={cancelButtonRef}
          className="resign-confirm__choice resign-confirm__choice--no"
          type="button"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          No
        </button>
        <button
          className="resign-confirm__choice resign-confirm__choice--yes"
          type="button"
          onClick={onConfirm}
          disabled={isSubmitting}
        >
          {isSubmitting ? "..." : "Yes"}
        </button>
      </div>
      {error ? <p className="resign-confirm__error">{error}</p> : null}
    </section>
  );
}
